import { render } from "./FilterContest.vue?vue&type=template&id=6f274be4&scoped=true"
import script from "./FilterContest.vue?vue&type=script&lang=js"
export * from "./FilterContest.vue?vue&type=script&lang=js"

import "./FilterContest.vue?vue&type=style&index=0&id=6f274be4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f274be4"

export default script